export default __webpack_public_path__ + "static/media/interBannerFebrero.3b26fc04.webp";